// extracted by mini-css-extract-plugin
export default {"formOutlined":"Header_formOutlined__mOuzc"};